// extracted by mini-css-extract-plugin
module.exports = {"md":"PollsHomeReminder_md_2jZuw","ios":"PollsHomeReminder_ios_Jz-mo","reminder":"PollsHomeReminder_reminder_1H9-U","icon":"PollsHomeReminder_icon_2Emfm"};